import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export const formatDate = (date: Date | string, withTime?: boolean) => {
   const local = dayjs.utc(date).local()
   return withTime ? local.format('YYYY-MM-DD HH:mm') : local.format('YYYY-MM-DD')
}

export const compareByDate = (a: string | Date, b: string | Date) => dayjs.utc(a).valueOf() - dayjs.utc(b).valueOf()
